import { getFocusedCommentContentId } from '@databases/database-state';
import React, { createContext, useState } from 'react';

export type OpenThread = {
  valueId: string | undefined;
  threadId?: string | undefined;
  create?: boolean;
  panel?: boolean;
};
export interface CommentContextInterface {
  openThread: OpenThread;
  setOpenThread: (value: OpenThread) => void;
  focusedCommentContentId: string | undefined;
  setFocusedCommentContentId: (threadId: string | undefined) => void;
}

export const CommentContext = createContext<CommentContextInterface>({
  openThread: { valueId: undefined },
  setOpenThread: () => {},
  focusedCommentContentId: undefined,
  setFocusedCommentContentId: () => {},
});

export const CommentProvider = ({ children }: { children: React.ReactNode }) => {
  const [openThread, setOpenThread] = useState<OpenThread>({ valueId: undefined });
  const [focusedCommentContentId, setFocusedCommentContentId] = useState<
    string | undefined
  >(getFocusedCommentContentId());

  return (
    <CommentContext.Provider
      value={{
        openThread,
        setOpenThread,
        focusedCommentContentId,
        setFocusedCommentContentId,
      }}
    >
      {children}
    </CommentContext.Provider>
  );
};
